<template>
    <div id="schoolDetails">
        <tabtop></tabtop>
        <div class="school1">
            <img  :src="url+banner.images" alt=""  @click="jumpbannerpage(banner.url)">
            <div class="school1Box">
                <ul>
                    <li v-for="(item,index) in classification" :key="index" :class="changeClassificationIndex==index?'on':''" @click="changeClassIndex(index)">{{item.title}}</li>
                </ul>
            </div>
        </div>
        <div class="school2" id="container">
            <div class="school3"> 
                <div class="school3Box">
                    <p class="articleTitle">{{article.title}}</p>
                    <p class="articleMsg">
                        <span>{{article.author}}</span>
                        <span>{{article.articletime}}</span>
                        <span>阅读：{{article.volume}}</span>
                    </p>
                    <img :src="url+banner2.images" alt="" class="img"  @click="jumpbannerpage(banner.url)">
                    <div v-html="article.content"></div>
                </div>
            </div>
            <div class="school4">
                <div class="school5">
                    <p class="title">标签</p>
                    <ul>
                        <li v-for="(item,index) in label" :key="index" @click="jumpLabel(item.title,item.id)">{{item.title}}</li>
                    </ul>
                </div>
                <div class="school6">
                    <p class="title">热门文章</p>
                    <ul>
                        <li v-for="(item,index) in popularArticle" :key="index" @click="jumpArticle(item.id)">
                            <div class="left"><img :src="url+item.image" alt=""></div>
                            <div class="right">
                                <p class="p1">{{item.title}}</p>
                                <p class="p2">{{item.articletime}}</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- <webbottom></webbottom> -->
    </div>
</template>

<script>
var that
import { rotationmap,hot,tip,articlede } from '@/api/api'
import tabtop from '@/components/tab/tab.vue'
import webbottom from '@/components/bottom/bottom.vue'
export default {
    name:"schoolLabel",
    components: {
        tabtop,
        webbottom
    },
    data(){
        return {
            url : window.url,
            banner: {}, 
            banner2:{},
            changeClassificationIndex:0,
            articleid:1,
            classification:[
                {
                    title:"运营干货",
                },
                {
                    title:"成功借鉴",
                },          
                {
                    title:"引流获客",
                },
                {
                    title:"客户营销",
                }
            ],
            article:{
                
            },
            popularArticle:[
                
            ],
            label:[
                
            ],
        }  
    },

    mounted(){
        that = this
        if(this.$route.query.id){
            that.articleid = this.$route.query.id
        }
        rotationmap({'type':2}).then((response) => {
            that.banner = response.data.data[0]
        })
        rotationmap({'type':11}).then((response) => {
            that.banner2 = response.data.data[0]
        })
        hot().then((response) => {
            for(let i=0;i<response.data.data.length;i++){
                response.data.data[i].createtime = that.filterTime(response.data.data[i].createtime)
            }
            that.popularArticle = response.data.data
        })
        tip().then((response) => {
            that.label = response.data.data
        })
        articlede({'id':that.articleid}).then((response) => {
            for(let i=0;i<response.data.data.length;i++){
                if(response.data.data[i].articletime==null){
                    response.data.data[i].articletime = that.filterTime(response.data.data[i].createtime)
                }
            }
            this.article = response.data.data[0]
            document.title = this.article.title;
            document.querySelector('meta[name="keywords"]').setAttribute('content', this.article.subtitle)
            document.querySelector('meta[name="description"]').setAttribute('content', this.article.subtitle)
            this.$nextTick(function(){
                document.getElementById('container').scrollIntoView();
            })
        })
        

    },
    methods:{
        filterTime(time) {
            const date = new Date(time*1000)
            const Y = date.getFullYear()
            const M = date.getMonth() + 1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1 
            const D = date.getDate()
            return `${Y}-${M}-${D}`
        },
        changeClassIndex(e){
            this.changeClassificationIndex = e
            this.$router.push(
                {
                    name:"school",
                    query:{changeClassificationIndex:e}
                }
            )
        },
        jumpLabel(e,y){
            this.$router.push(
                {
                    name:"schoolLabel",
                    query:{label:e,id:y}
                }
            )
        },
        jumpArticle(e){
            that.articleid = e
            articlede({'id':that.articleid}).then((response) => {
                for(let i=0;i<response.data.data.length;i++){
                    response.data.data[i].createtime = that.filterTime(response.data.data[i].createtime)
                }
                this.article = response.data.data[0]
            })
        },
        jumpbannerpage(e){
            if(e != this.$route.path) {
                this.$router.push(e)
            }
        }
    }
}
</script>

<style lang="less">
@media (min-width:750px) {
    #schoolDetails{
        .school1{
            position: relative;
            img{
                width: 100%;
                display: block;
            }
            .school1Box{
                position: absolute;
                top: 50%;
                left: 37%;
                width: 1400px;
                transform: translate(-50%,-50%);
                display: flex;
                justify-content: center;
                ul{
                    display: flex;
                    width: 432px;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    li{
                        width: 200px;
                        height: 80px;
                        border-radius: 66px 66px 66px 66px;
                        border: 2px solid #FFFFFF;
                        color: #FEFEFE;
                        font-size: 26px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;
                    }
                    li:nth-child(-n+2){
                        margin-bottom: 20px;
                    }
                    .on{
                        background: #FFFFFF;
                        color: #355EFC;
                    }
                }
            }

        }
        .school2{ 
            display: flex;
            justify-content: center;
            width: 1300px;
            margin:60px auto 60px;
            .school3{
                margin-right: 16px;
                width: 900px;
                background: #FFFFFF;
                box-shadow: 0px 0px 6px 1px rgba(0,0,0,0.16);
                border-radius: 20px 20px 20px 20px;
                .title{
                    font-size: 24px;
                    font-weight: normal;
                    color: #AAAAAA;
                    padding: 32px;
                    margin-bottom: 32px;
                    border-bottom: 1px solid #F1F1F1;
                }
                .school3Box{    
                    padding: 30px;         
                    .img{
                        width: 100%;
                        margin-bottom: 16px;
                    }
                    .articleTitle{
                        font-size: 32px;
                        font-weight: normal;
                        color: #4F4F4F;
                        margin-bottom: 12px;
                    }
                    .articleMsg{
                        margin-bottom: 12px;
                        span{
                            margin-right: 16px;
                            font-size: 16px;
                            font-weight: 400;
                            color: #AAAAAA;
                        }
                        span:nth-child(1){
                            color: #3D65FC;
                        }
                    }
                }

            }
            .school4{
                width: 360px;
                .school5{
                    box-shadow: 0px 0px 6px 1px rgba(0,0,0,0.16);
                    border-radius: 20px 20px 20px 20px;
                    padding: 32px 0;
                    margin-bottom: 28px;
                    .title{
                        font-size: 32px;
                        font-weight: bold;
                        color: #515151;
                        padding: 0 32px 20px;
                        border-bottom: 1px solid #F1F1F1;
                        margin-bottom: 20px;
                    }
                    ul{
                        display: flex;
                        flex-wrap: wrap;
                        padding: 0 20px 0 10px;
                        justify-content: space-between;
                        li{
                            width: 140px;
                            background: #E7EAFF;
                            border-radius: 8px 8px 8px 8px;
                            text-align: center;
                            padding: 8px;
                            font-size: 16px;
                            font-weight: 400;
                            color: #355EFC;
                            margin-bottom: 10px;
                            cursor: pointer;
                        }
                    }
                }
                .school6{
                    box-shadow: 0px 0px 6px 1px rgba(0,0,0,0.16);
                    border-radius: 20px 20px 20px 20px;
                    padding: 32px 0;
                    margin-bottom: 28px;
                    .title{
                        font-size: 32px;
                        font-weight: bold;
                        color: #515151;
                        padding: 0 32px 20px;
                        border-bottom: 1px solid #F1F1F1;
                        margin-bottom: 20px;
                    }
                     ul{
                        li{
                            display: flex;
                            margin-bottom: 8px;
                            border-bottom: 1px solid #F1F1F1;
                            cursor: pointer;
                            padding: 0 20px 8px;
                            .left{
                                img{
                                    width: 80px;
                                    margin-right: 16px;
                                }
                            }
                            .right{
                                .p1{
                                    width: 220px;
                                    font-size: 16px;
                                    font-weight: 400;
                                    color: #383838;
                                    margin-bottom: 10px;
                                    white-space: nowrap;
                                    overflow: hidden;//文本超出隐藏
                                    text-overflow: ellipsis;//文本超出省略号替代
                                }
                                .p2{
                                    font-size: 16px;
                                    font-weight: 400;
                                    color: #AAAAAA;
                                }
                            }
                        }
                        li:last-child{
                            border-bottom: none!important;
                            margin-bottom: 0;
                            padding-bottom: 0;
                        }
                    }
                }
            }
        }
    }
}
@media screen and (max-width:750px) {
    #schoolDetails{
        .school1{
            position: relative;
            img{
                width: 100%;
                display: block;
            }
            .school1Box{
                position: absolute;
                top: 50%;
                left: 50%;
                width: 100%;
                transform: translate(-50%,-50%);
                ul{
                    margin:1.25rem 0.625rem 0;
                    display: flex;
                    width: 48%;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    li{
                        flex: 0 0 40%;
                        height: 1.875rem;
                        border-radius: 4.125rem 4.125rem 4.125rem 4.125rem;
                        border: 2px solid #FFFFFF;
                        color: #FEFEFE;
                        font-size: 0.75rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;
                    }
                    li:nth-child(-n+2){
                        margin-bottom: 0.625rem;
                    }
                    .on{
                        background: #FFFFFF;
                        color: #355EFC;
                    }
                }
            }
        }
        .school2{ 
           display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            width: 100%;
            margin:1.25rem auto 0;
            .school3{
                flex: 0 0 100%;
                margin-bottom: 1.25rem;
                .school3Box{
                    width: 90%;
                    margin:1.25rem auto;
                    box-shadow: 0rem 0rem 0.375rem 0.0625rem rgba(0,0,0,0.16);
                    border-radius: 1.25rem 1.25rem 1.25rem 1.25rem;
                    .title{
                        font-size: 1.25rem;
                        font-weight: bold;
                        color: #515151;
                        padding: 0 2rem 1.25rem;
                        border-bottom: 0.0625rem solid #F1F1F1;
                        margin-bottom: 1.25rem;
                    }           
                    .img{
                        width: 100%;
                        margin-bottom: 1rem;
                    }
                    padding: 2rem 1rem;
                    .articleTitle{
                        font-size: 1.5rem;
                        font-weight: normal;
                        color: #4F4F4F;
                        margin-bottom: 0.75rem;
                    }
                    .articleMsg{
                        margin-bottom: 0.75rem;
                        span{
                            margin-right: 1rem;
                            font-size: 1rem;
                            font-weight: 400;
                            color: #AAAAAA;
                        }
                        span:nth-child(1){
                            color: #3D65FC;
                        }
                    }
 
                }

            }
            .school4{
                width: 100%;
                .school5{
                    box-shadow: 0rem 0rem 0.375rem 0.0625rem rgba(0,0,0,0.16);
                    border-radius: 1.25rem 1.25rem 1.25rem 1.25rem;
                    padding: 2rem 0;
                    width: 90%;
                    margin:1.25rem auto;
                    .title{
                        font-size: 2rem;
                        font-weight: bold;
                        color: #515151;
                        padding: 0 2rem 1.25rem;
                        border-bottom: 0.0625rem solid #F1F1F1;
                        margin-bottom: 1.25rem;
                    }
                    ul{
                        display: flex;
                        flex-wrap: wrap;
                        padding: 0 1.25rem 0 0.625rem;
                        justify-content: space-between;
                        li{
                            width: 8.75rem;
                            background: #E7EAFF;
                            border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
                            text-align: center;
                            padding: 0.5rem;
                            font-size: 1rem;
                            font-weight: 400;
                            color: #355EFC;
                            margin-bottom: 0.625rem;
                            cursor: pointer;
                        }
                    }
                }
                .school6{
                    box-shadow: 0rem 0rem 0.375rem 0.0625rem rgba(0,0,0,0.16);
                    border-radius: 1.25rem 1.25rem 1.25rem 1.25rem;
                    padding: 2rem 0;
                    width: 90%;
                    margin:1.25rem auto;
                    .title{
                        font-size: 2rem;
                        font-weight: bold;
                        color: #515151;
                        padding: 0 2rem 1.25rem;
                        border-bottom: 0.0625rem solid #F1F1F1;
                        margin-bottom: 1.25rem;
                    }
                    ul{
                        li{
                            display: flex;
                            margin-bottom: 0.5rem;
                            border-bottom: 0.0625rem solid #F1F1F1;
                            cursor: pointer;
                            padding: 0 1.25rem 0.5rem;
                            .left{
                                img{
                                    width: 5rem;
                                    margin-right: 1rem;
                                }
                            }
                            .right{
                                .p1{
                                    width: 12.5rem;
                                    font-size: 1rem;
                                    font-weight: 400;
                                    color: #383838;
                                    margin-bottom: 0.625rem;
                                    white-space: nowrap;
                                    overflow: hidden;
                                    //文本超出隐藏 text-overflow: ellipsis;
                                    //文本超出省略号替代 
                                }
                                .p2{
                                    width: 12.5rem;
                                    font-size: 1rem;
                                    font-weight: 400;
                                    color: #AAAAAA;
                                }
                            }
                        }
                        li:last-child{
                            border-bottom: none!important;
                            margin-bottom: 0;
                            padding-bottom: 0;
                        }
                    }
                }
            }
        }
    }
}
</style>